// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UWl2","title":"styles_title__2hkcQ"};